import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { Message } from 'element-ui'
import store from '@/store'
import i18n from '@/i18n/i18n.js'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	mode: 'history',
	//   mode: 'hash',
	routes,

})

router.beforeEach((to, from, next) => {
	let url = location.href
	let urlCopoy = null
	let numUrl = null
	if (url.indexOf('shopsooo') > -1) {
		urlCopoy = url.split('/')
		let num = null
		urlCopoy.forEach((p, index) => {
			if (p.indexOf('shopsooo') > -1) {
				num = index
			}
		})
		numUrl = urlCopoy[num]
	}

	console.log('numUrl', numUrl)
	console.log('to', to)
	console.log(store, 'store')

	if (to.matched.some(record => record.meta.requiresAuth)) {
		let userInfo = JSON.parse(localStorage.getItem('userInfo'))

		if (to.path == '/home/en') {
			store.commit('login/SWITCH_LANG', 'en')
			i18n.locale = 'en';
		}
		if (!userInfo) {
			Message({
				message: '用户尚未登录,请先登录！',
				type: 'warning'
			})
			if (to.path == '/loginPage') {

				next()
			} else {
				next('/loginPage')
			}
		} else {

			next()
		}
	} else if (numUrl) {
		//如果是包一层的用户访问首页，直接跳转登录页
		if ((numUrl !== 'www.shopsooo.com' && to.fullPath == '/' && numUrl.indexOf('shopsooo') > -1)) {
			next('/loginPage')
		} else {
			next()
		}
	} else {
		if (to.fullPath == '/' && url.indexOf('shopsbu') > -1) {
			next('/loginPage')
		} else {
			next()
		}
	}
})

export default router
